export default __webpack_public_path__ + "static/media/maps.0e907d3d.jpg";